module.exports = __webpack_public_path__ + "img/ac9_thumb.3301ef41.jpg";